import { xcss, XCSS } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const LOADING_CONTAINER_HEIGHT = '100px';
const CONTAINER_MIN_HEIGHT = '52px';

export const popupContentContainer = (loading: boolean, error: boolean): XCSS =>
  xcss({
    font: 'font.body',
    width: '600px',
    overflowY: 'auto',
    minHeight: loading ? LOADING_CONTAINER_HEIGHT : CONTAINER_MIN_HEIGHT,
    maxHeight: loading ? LOADING_CONTAINER_HEIGHT : '400px',
    transition: 'min-height 0.5s, max-height 0.5s',
    transformOrigin: 'bottom',
    padding: 'space.200',
    backgroundColor: error ? 'color.background.danger' : undefined,
  });

export const portalContentContainer = (
  loading: boolean,
  error: boolean,
  aiOutput: string
): XCSS => {
  /*
    For Portal content we dont set a specific maxHeight to avoid content scrolling.
    However, in order for maxHeight to transition it needs to go between 2 values.
    We approximate a maxHeight by counting the number of lines in the output.
    We ensure the approximation is an over-estimate so we can have a reasonable
    transition but to avoid content scrolling.
  */
  const approxOutputHeight = aiOutput.split('\n').length * 35;
  const calculateMaxHeight = () => {
    if (loading) return LOADING_CONTAINER_HEIGHT;
    if (aiOutput) return `${approxOutputHeight}px`;

    return 'unset';
  };

  const calculateTransform = () => {
    if (aiOutput) {
      const transitionTime = approxOutputHeight / 1000;
      return `min-height ${transitionTime}s, max-height ${transitionTime}s`;
    }

    return 'min-height 0.5s, max-height 0.5s';
  };

  return xcss({
    font: 'font.body',
    minHeight: loading ? LOADING_CONTAINER_HEIGHT : CONTAINER_MIN_HEIGHT,
    maxHeight: calculateMaxHeight(),
    transition: calculateTransform(),
    transformOrigin: 'bottom',
    padding: 'space.200',
    backgroundColor: error ? 'color.background.danger' : undefined,
  });
};

export const popupFooterContainer = xcss({
  paddingBlock: 'space.050',
  paddingInline: 'space.150',
  borderTop: `1px solid ${token('color.border')}`,
  font: 'font.body',
  color: 'color.text.subtlest',
});

export const popupFooterFlexContainer = xcss({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'relative',
});

export const popupFooterContent = xcss({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 'space.050',
});

export const actionContainer = xcss({
  marginTop: 'space.250',
});

export const closePortalButtonContainer = xcss({
  position: 'absolute',
  top: '2px',
  right: '2px',
  margin: 'space.075',
  padding: 'space.100',
});

export const portalContainer = xcss({
  marginBlock: 'space.200',
});
